<template>
  <div>
    <component :is="tag" :class="computedClass" :style="computedStyle" data-testid="text-component">
      <slot></slot>
    </component>
  </div>
</template>

<script>
const SIZE = {
  tiny: '_size_tiny', // 11px
  small: '_size_small', // 12px
  medium: '_size_medium', // 14px
  regular: '_size_regular ', // 16px
  section: '_size_section', // 16px Bold
  subpage: '_size_subpage', // 20px
  page: '_size_page', // 24px
  display: '_size_display', // 42px
  huge: '_size_huge' // 52px
}

export default {
  name: 'EmdText',

  props: {
    size: {
      type: String,
      default: 'section',
      validation: size => Object.keys(SIZE).includes(size)
    },
    tag: {
      type: String,
      required: false,
      default: 'span'
    },
    color: String
  },
  computed: {
    computedClass () {
      return ['emd-text', SIZE[this.size]]
    },
    computedStyle () {
      return { color: this.color }
    }
  }
}
</script>

<style>
.emd-text._size_medium {
  font-size: 14px;
}
.emd-text._size_regular {
  font-size: 16px;
}
</style>
